package com.oscarherreros.appcalculo.game

private const val SEPARATOR = ";"

/** Números y objetivo del nivel, para comprobar que una partida guardada es suya. */
private val Level.signature: String get() = numbers.joinToString(",") + ">" + target

/** Hay algo que conservar: jugadas hechas o pistas usadas en una partida sin terminar. */
val GameState.worthSaving: Boolean
    get() = !solved && (steps.isNotEmpty() || hintsUsed > 0)

/**
 * Lo necesario para reanudar la partida: el nivel al que pertenece, las pistas
 * usadas, si hay una a la vista y las jugadas hechas, cada una como «hueco de
 * origen, operación, hueco de destino».
 */
fun GameState.encode(): String {
    val moves = fuses.zip(steps) { fuse, step -> "${fuse.from},${step.op.name},${fuse.to}" }
    return (listOf(level.signature, hintsUsed, if (hint != null) 1 else 0) + moves).joinToString(SEPARATOR)
}

/**
 * Reconstruye sobre [level] la partida guardada con [encode]. Repite las
 * jugadas una a una, así que también recupera el historial de deshacer.
 * Devuelve null si el texto está dañado o es de otro nivel, como pasaría con
 * una partida guardada antes de un cambio en la generación de niveles.
 */
fun restoreGame(level: Level, saved: String): GameState? {
    val fields = saved.split(SEPARATOR)
    if (fields[0] != level.signature) return null
    return runCatching {
        val replayed = fields.drop(3).fold(GameState(level)) { state, move ->
            val (from, op, to) = move.split(",")
            // Tras cada jugada queda seleccionado el resultado: se suelta para no deseleccionarlo al tocarlo.
            val next = state.copy(selected = null).tapTile(from.toInt()).tapOp(Op.valueOf(op)).tapTile(to.toInt())
            check(next.steps.size == state.steps.size + 1) { "jugada no válida: $move" }
            next
        }
        // La pista que estaba a la vista ya se pagó: se vuelve a enseñar sin contarla otra vez.
        val hinted = if (fields[2] == "1") replayed.requestHint() else replayed
        hinted.copy(selected = null, hintsUsed = fields[1].toInt())
    }.getOrNull()
}
